/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { useCompetitionsList } from '@api/hooks';

import SearchableEntitySelect from '../SearchableEntitySelect';

const CompetitionSelect = ({ placeholder = 'Type to search competition', ...props }) => (
  <SearchableEntitySelect placeholder={placeholder} useList={useCompetitionsList} {...props} />
);

export default CompetitionSelect;
